// extracted by mini-css-extract-plugin
export default {"main":"landing_main__MBoV-","inner_main":"landing_inner_main__Jk7Mo","left":"landing_left__jNSK8","right":"landing_right__nkVDz"};